var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('CoverPage'),_c('LatestNews'),_c('DownloadCard'),_c('div',{staticClass:"bge3ceff-opa rounded-t-5555 mt-12 relative zindex1"},[_c('DownloadApp'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }